// extracted by mini-css-extract-plugin
export var childrenContainer = "_bc-0";
export var virtualScrollArea = "_bc-1";